module.exports = __webpack_public_path__ + "img/XBS.c5423ec4.svg";